import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from 'src/shared/material/material.module';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

export function tokenGetter() {
	const storage = environment.activeDirectoryOptions.cacheLocation;
	const resource = environment.activeDirectoryOptions.clientId;
	let key;
	if (resource) {
		key = 'adal.access.token.key' + resource;
	} else {
		key = 'adal.idtoken';
	}
	if (storage === 'localStorage') {
		return localStorage.getItem(key);
	} else {
		return sessionStorage.getItem(key);
	}
}

@NgModule({
	declarations: [],
	imports: [CommonModule, MaterialModule, FlexLayoutModule],
})
export class AuthModule {
	static forRoot(adalConfig: any): ModuleWithProviders<AuthModule> {
		return {
			ngModule: AuthModule,
			providers: [
				AuthService,
				{
					provide: 'adalConfig',
					useValue: adalConfig,
				},
			],
		};
	}
}
